import cn from 'classnames'
import styles from './VNCategoryDropdownModal.module.scss'
import { ButtonBase } from '@material-ui/core'
import { ReactComponent as CloseIcon } from '../../assets/icons/Close-Icon.svg'
import { getSelectedCategory } from '../Selectors'
import { getSortedItemCategories } from '../../selectors/itemCategory'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { CATEGORY_DEFAULTS } from './VNCategories'
import { isE700Device } from '../../VNAndroidSDK/Utils'

const VNCategoryDropdownModal = ({ handleClick, handleClose }) => {
  const itemCategoriesSorted = useSelector(getSortedItemCategories)
  const curCategory = useSelector(getSelectedCategory)
  const categories = useMemo(() => [...CATEGORY_DEFAULTS, ...Object.values(itemCategoriesSorted)], [itemCategoriesSorted])

  const CategoryItem = ({ category }) => {
    const categoryId = category.itemCategoryUuid || category.id
    const isSelected = categoryId === curCategory
    const categoryName = category.label ?? category.name

    return (
      <ButtonBase
        disableRipple={isE700Device()}
        component="div"
        key={categoryId}
        className={cn(styles.category, { [styles.selected]: isSelected })}
        onClick={() => handleClick(categoryId)}
      >
        <div>{categoryName}</div>
        <div>{category.itemCount}</div>
      </ButtonBase>
    )
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.closeButton}>
          <CloseIcon onClick={handleClose} />
        </div>
        <div className={styles.list}>
          {categories.map((category, idx) => (
            <CategoryItem key={idx} category={category} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default VNCategoryDropdownModal
